export default __webpack_public_path__ + "static/media/home_healthcare_steps.17a47146.webp";